import { render } from "./FloatingNavButtons.vue?vue&type=template&id=5d47248e&scoped=true"
import script from "./FloatingNavButtons.vue?vue&type=script&lang=js"
export * from "./FloatingNavButtons.vue?vue&type=script&lang=js"

import "./FloatingNavButtons.vue?vue&type=style&index=0&id=5d47248e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d47248e"]])

export default __exports__